import AdvancedSelectField from '@shared/AdvancedSelectField/components/AdvancedSelectField';

export default AdvancedSelectField;
